import { useState } from 'react';
import { Typography } from '@mui/material';
import { updateMeta } from '../../../redux/meta';
import { useAppDispatch } from '../../../pages/assessment';
import { AssessmentButtons, AssessmentCrisisAlert } from '../shared';

const ZocdocIntroductionSecond = () => {
  const dispatch = useAppDispatch();

  const [isContinuing, setIsContinuing] = useState(false);
  const onClick = () => {
    setIsContinuing(true);
    dispatch(updateMeta());
  };

  return (
    <>
      <Typography>We want to make sure:</Typography>
      <ul style={{ listStyleType: 'disc', marginTop: '3px' }}>
        <li>The clinician you chose is licensed in your state</li>
        <li>We take your insurance</li>
        <li>We can provide the kind of care you need</li>
      </ul>
      <Typography>
        If the clinician you chose isn't the right fit for you, we'll also help
        you find one who is.
      </Typography>
      <AssessmentCrisisAlert />
      <AssessmentButtons
        primary={{
          children: 'Continue',
          disabled: isContinuing,
          loading: isContinuing,
          onClick,
        }}
      />
    </>
  );
};

export default ZocdocIntroductionSecond;
